import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ReallocationSource, ReallocationTarget } from '../../../types/reallocation/Reallocation'
import { createReallocationTarget } from '../service/reallocationService'
import { useContextParameters } from '../../../services/api/hooks/useContextParameters'
import reallocationQueryKeys from './reallocationQueryKeys'
import invalidateReportQueries from './invalidateReportQueries'

interface CreateReallocationTargetVariables {
  target: ReallocationTarget
  source: ReallocationSource
}

export const useCreateReallocationTarget = () => {
  const { companyId } = useContextParameters()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ target, source }: CreateReallocationTargetVariables) => {
      if (!companyId) {
        throw new Error('Company ID is required')
      }
      const createdTarget = await createReallocationTarget(target, companyId, source.id)
      return { target: createdTarget, source }
    },
    onSuccess: ({ target, source }) => {
      queryClient.setQueryData<ReallocationSource[]>(reallocationQueryKeys.list({ companyId }), old => {
        if (!Array.isArray(old)) return old
        return old.map(item => (item.id === source.id ? { ...item, targets: [...(item.targets || []), target] } : item))
      })
      invalidateReportQueries(queryClient)
    },
    onError: error => {
      console.error('Failed to create reallocation target:', error)
    }
  })
}
